/* Clasificación por edades. Los paneles la informan de mil maneras ("+12", "12", "PG-13",
   "TV-MA", "R", "TP", "Apta para todos los públicos"…): aquí se normaliza a una edad mínima
   numérica (null si no se reconoce) y a una etiqueta corta para mostrar. */

const TABLE = [
    [/^(tp|g|tv-g|tv-y|u|apta|todos|all)/, 0],
    [/^tv-y7/, 7],
    [/^(pg|tv-pg)$/, 10],
    [/^pg-?13/, 13],
    [/^tv-14/, 14],
    [/^tv-ma/, 17],
    [/^(r|m)$/, 17],
    [/^(nc-?17|x|xxx|adult)/, 18]
];

export function parseAge(value) {
    const raw = String(value == null ? '' : value).trim();
    if (!raw) return { min: null, label: '' };
    const s = raw.toLowerCase();
    const num = /(\d{1,2})/.exec(s);
    if (num && !/^(pg-?13|tv-14|tv-y7|nc-?17)/.test(s)) {
        const n = Number(num[1]);
        if (n >= 0 && n <= 21) return { min: n, label: n === 0 ? 'TP' : '+' + n };
    }
    for (const [re, min] of TABLE) {
        if (re.test(s)) return { min, label: min === 0 ? 'TP' : '+' + min };
    }
    return { min: null, label: raw.slice(0, 12) };
}

/** true si el título (por su clasificación) supera la edad máxima del espectador. */
export function exceedsAge(value, maxAge) {
    if (maxAge == null) return false;
    const a = parseAge(value);
    return a.min != null && a.min > Number(maxAge);
}
